import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  revenueBreakdownQuery({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`revenueQuery/revenueBreakdownQuery`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportRevenueBreakdownQuery({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`revenueQuery/exportRevenueBreakdownQuery`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  revenueQuery({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`revenueQuery/revenueQuery`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findDeptPrice({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`revenueQuery/findDeptPrice`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportRevenueQuery({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`revenueQuery/exportRevenueQuery`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
